module.exports = __webpack_public_path__ + "img/volume_off.4fc476b6.svg";